import api from './api';
import { showSuccess, showError } from '@/utils/toastHelper';

/**
 * Creates a new order
 * @param {object} orderData - Order data to submit
 * @returns {Promise<object>} Response data with orderId and reference
 */
export const createOrder = async (orderData) => {
	const response = await api.post('/orders/create', orderData);
	return response.data;
};

/**
 * Verifies and applies a reorder discount promo code
 * @param {string} restaurantId - Restaurant ID
 * @param {string} code - Promo code to verify
 * @param {number} totalPrice - Total price of the order
 * @param {string} userEmail - User email
 * @param {string} userPhone - User phone
 * @returns {Promise<object>} Promo data if valid
 * @throws {Error} If promo code is invalid or user is already referred
 */
export const applyReorderDiscount = async (restaurantId, code, totalPrice, userEmail, userPhone) => {
	try {
		const response = await api.post(
			`/restaurants/${restaurantId}/promos/${code.toUpperCase()}/verify`,
			{
				totalPrice,
				userEmail: userEmail || '',
				userPhone: userPhone || '',
			}
		);

		if (response.data.valid) {
			showSuccess(`Code promo appliqué : ${response.data.promo.reference}`, {
				autoClose: 800,
			});
			return response.data.promo;
		}

		throw new Error('Invalid promo code');
	} catch (error) {
		if (error.response?.data?.isAlreadyReferred || 
		    (error.response?.data?.message && error.response.data.message.includes('déjà filleul'))) {
			showError('Vous êtes déjà filleul d\'un autre parrain. Vous ne pouvez pas utiliser un autre code de parrainage.');
			throw new Error('ALREADY_REFERRED');
		}

		const errorMessage = error.response?.data?.message || 'Erreur lors de l\'application du code promo';
		showError(errorMessage);
		throw error;
	}
};

